import product1 from "./assets/products/10.jpg";
import product2 from "./assets/products/11.webp";
import product3 from "./assets/products/12.webp";
import product4 from "./assets/products/13.jpg";
import product5 from "./assets/products/14.jpg";
import product6 from "./assets/products/15.webp";
import product7 from "./assets/products/16.jpg";
import product8 from "./assets/products/17.jpg";
import product9 from "./assets/products/18.jpg";

export const BPRODUCTS = [
  {
    id: 1,
    productName: "Pull homme à col rond",
    describetion :"" ,
    price: 449,
    productImage: product1,
  },
  {
    id: 2,
    productName: "Blouson bombardier homme",
    describetion :"" ,
    price: 349,
    productImage: product2,
  },
  {
    id: 3,
    productName: "Blouson a manches contrastantes",
    describetion :"" ,
    price: 899,
    productImage: product3,
  },
  {
    id: 4,
    productName: "Jean homme coupe Regular",
    describetion :"" ,
    price: 699,
    productImage: product4,
  },
  {
    id: 5,
    productName: "Manteau homme court",
    describetion :"" ,
    price: 819,
    productImage: product5,
  },
  {
    id: 6,
    productName: "Pyjama homme",
    describetion :"" ,
    price: 979,
    productImage: product6,
  },
  {
    id: 7,
    productName: "Pull homme à col roulé",
    descrebtion :"" ,
    price: 449,
    productImage: product7,
  },
  {
    id: 8,
    productName: "Pull de Noël homme",
    price: 399,
    productImage: product8,
  },
  {
    id: 9,
    productName: "ensemble polo tee-shirt et pantalon de la toile",
    price: 1399,
    productImage: product9,
  },
];
